// @ts-nocheck
import * as _111 from "./gogo";
export const gogoproto = {
  ..._111
};